module.exports = __webpack_public_path__ + "img/repguide-wartung-diagnose.e696178b.jpg";